export default __webpack_public_path__ + "static/media/logo.2d1c62d5.png";